import React, { Component, useState, useEffect, useRef } from "react";
import {
  Link,
  useParams,
  Router,
  useNavigate,
  useLocation,
} from "react-router-dom";
import {
  Row,
  Col,
  Container,
  Button,
  ModalHeader,
  ModalFooter,
  Modal,
  ModalBody,
  Alert,
} from "reactstrap";

import $ from "jquery";
import Header from "../header.js";
import Faculty from "../Faculty/Faculty.js";
import Footer from "../footer.js";
import scan from "../../images/scan.png";
import play from "../../images/play.png";
import bnrimg from "../../images/bnrimg.png";

import web1 from "../../images/web1.png";
import web2 from "../../images/web2.png";
import web3 from "../../images/web3.png";
import web4 from "../../images/web4.png";
import web5 from "../../images/web5.png";
import web6 from "../../images/web6.png";
import download from "../../images/download.svg";
import aboutimg from "../../images/aboutimg.png";
import { API_URL } from "../../../Config/index.js";
import { Helmet } from "react-helmet";
import PregencyBrochure from "./PregencyBrochure.js";
import RespirationBrochure from "./RespirationBrochure.js";
import CapnolearningBrochure from "./CapnolearningBrochure.js";
import HighPerformaceRespiration from "./HighPerformaceRespiration.js";

const SpecialRegisterform = () => {
  const [show, setShow] = useState(false);
  const [showBrochure, setShowBrochure] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [userId, setUserId] = useState(null);
  const [course, setCourse] = useState(null);


  const [installmentDates, setInstallmentDates] = useState([]);
  const [balanceDate, setBalanceDate] = useState(null);
  const [rawBalanceDate, setRawBalanceDate] = useState(null);

  const [trimester, setTrimester] = useState(null);
  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [email, setEmail] = useState("");
  const [confirmemail, setConfirmEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [telofficeNo, setTelofficeNo] = useState("");
  const [telcellNo, setTelcellNo] = useState("");
  const [address1, setAddress1] = useState("");
  const [address2, setAddress2] = useState("");
  const [country, setCountry] = useState("");
  const [state, setState] = useState("");
  const [city, setCity] = useState("");
  const [postalcode, setPostalcode] = useState("");
  const [profession, setProfession] = useState("");
  const [highestdegreeearned, setHighestdegreeearned] = useState("");
  const [degreeinwhatfield, setDegreeinwhatfield] = useState("");
  const [yeardegreeearned, setyeardegreeearned] = useState("");
  const [licenses, setLicenses] = useState("");
  const [certifications, setCertifications] = useState("");
  const [yearsofprofessionalexperience, setYearsofprofessionalexperience] =
    useState("");
  const [whoreferredyou, setWhoreferredyou] = useState("");
  const [showOtherRefer, setShowOtherRefer] = useState(false);
  const [source, setSource] = useState(null);
  const refervalue = (e) => {
    setWhoreferredyou(e.target.value)
    if (e.target.value == "Other: Please specify source") {
      setShowOtherRefer(true)
    }
  }
  const referer = localStorage.getItem("referer");
  const [mail, setMail] = useState("");
  const [pass, setPass] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [alertM, setAlertMM] = useState(false);
  const [existingUserId, setExistingUserId] = useState(null);
  const [newUserId, setNewUserId] = useState(null);
  const [registering, setRegistering] = useState(false);

  const cvFile = useRef();
  const { slug } = useParams();
  const [successModal, setsuccessModal] = useState(false);
  const [p_brochure, setP_brochure] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const successToggleModal = () => setsuccessModal(!successModal);
  const [depositEnabled, setDepositEnabled] = useState(false);
  const [rentalOption, setRentalOption] = useState(null);
  const [rentalOpted, setRentalOpted] = useState(null);
  const [programRequisitModal, setProgramRequisitModal] = useState(false);
  const [prereq, setPrereq] = useState(null);
  const [instalmentEnabled, setInstalmentEnabled] = useState(false);
  const [installmentDueDates, setInstallmentDueDates] = useState([]);
  const installmentFee = 50;
  const [loginModel, setLoginModel] = useState(false);
  const LoginToggleModal = () => setLoginModel(!loginModel);
  useEffect(() => {
    if (
      (slug === "breathing-science-for-birth-professionals" ||
        slug === "optimizing-respiration-for-achieving-high-performance" ||
        slug === "optimizing-respiration-for-high-performance" ||
        slug === "capnolearning" ) && showBrochure != 1
    ) {
      setP_brochure(true);
    } else {
      setP_brochure(false);
    }
  }, [slug]);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const showBrochure_ = queryParams.get("showbrochure");

  useEffect(() => {
    if (slug === "capnolearning") {
      setShow(!show);
    }
     if (slug === "capnolearning-fall-2025" || slug === "capnolearning-winter-2025" || slug === "capnolearning-high-perfommance-winter-2025" ) {
      setShow(!show);
    }
  }, [slug,showBrochure_]);

  const [messageModal, setmessageModal] = useState(false);
  const messageToggle = () => setmessageModal(!messageModal);
  const [message, setmessage] = useState(false);
  const [messageHead, setmessageHead] = useState(false);

  const [countries, setCountries] = useState([]);

  const [payPalModal, setPayPalModal] = useState(false);
  const payPalToggle = () => setPayPalModal(!payPalModal);

   const [loaderModal, setLoaderModal] = useState(false);
  const loaderToggle = () => setLoaderModal(!loaderModal);

   const [errorModal, setErrorModal] = useState(false);
  const errorToggle = () => setErrorModal(!errorModal);

  const [selectedOption, setSelectedOption] = useState("total");

  const handleChange = (event) => {
    setSelectedOption(event.target.value);
  };
  const Navigate = useNavigate();
  // const [alert, setAlertM] = useState(false);
  const [price, setPrice] = useState("Fetching...");
  const [brochureLink, setBrochureLink] = useState("");
  const [damount_new, setDamount_new] = useState("");
  const [bamount_new, setBamount_new] = useState("");

    const [damount, setDamount] = useState("");
  const [bamount, setBamount] = useState("");

  const [courseName, setCourseName] = useState("");

  const [balanceAmount, setBalanceAmount] = useState(0);
  const [balanceAmountDiscount, setBalanceAmountDiscount] = useState(0);
  const [totalCostDiscount, setTotalCostDiscount] = useState(0);
  const [totalActualCost, setTotalActualCost] = useState(0);

  const [scholarshipCode, setScholarshipCode] = useState(null);
  const [poNumber, setPoNumber] = useState(null);
  const [totalCost, setTotalCost] = useState(0);
  const [scapplied, setScapplied] = useState(null);
  const [poapplied, setPoapplied] = useState(null);
  const [codeError, setCodeError] = useState(null);
  const [checkoutsuccessModel, setCheckoutsuccess] = useState(false);
  const checkoutsuccessToggleModal = () =>
    setCheckoutsuccess(!checkoutsuccessModel);
  useEffect(() => {
    //    getPrice()
    getCountries();
    getCourse();
   
    
  }, [email]);

  const getCourse = async () => {
    const response = await fetch(API_URL + "/get/coursebyslug/" + slug, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    const data = await response.json();
    
    if (data.success) {

      // console.log(data.data[0].damount_new);
      setDepositEnabled(parseInt(data.data[0].pay_deposit_balance_day))
      setInstalmentEnabled(parseInt(data.data[0].pay_deposit_installment))
      setBrochureLink(data.data[0].course_url);
      setDamount_new(data.data[0].damount_new);
      setBamount_new(data.data[0].bamount_new);
      setRentalOption(data.data[0].rentalOption);
      setPrereq(data.data[0].Prereq);
//  console.log("data",data.data[0]);
      setDamount(data.data[0].damount);
      setBamount(data.data[0].bamount);
      setRawBalanceDate(data.data[0].bc_date * 1000)
      setBalanceDate(formatDate(data.data[0]?.bc_date))
     
      const timestamps = data?.data[0]?.insfudates?.split(",")
      const formattedDates = timestamps?.map(ts => {
  return formatDate(ts);
});

// setInstallmentDates(formattedDates)
 console.log("data",data.data[0]);
      setPrice(data.data[0].price);
      setTotalActualCost(data.data[0].price);
      setTotalCost(data.data[0].price);
      setTrimester(data.data[0].semesters);
      setCourse(data.data[0].id);
      setCourseName(data.data[0].coursecode + " " + data.data[0].course);
    }
  };
  const formatDate = (ts) => {
    const date = new Date(ts * 1000); // Convert seconds to milliseconds
  const day = date.getDate().toString().padStart(2, '0');
  const month = date.toLocaleString('en-US', { month: 'short' });
  return `${day}-${month}`;
  }

  const getCountries = async () => {
    const response = await fetch(API_URL + "/countries/", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    const data = await response.json();
    if (data.status) {
      setCountries(data.countries);
    }
  };


  const [states, setStates] = useState([])

  useEffect(() => {
    getStates();
  }, [country])

  const getStates = async () => {
    const response = await fetch(API_URL + "/states?country_id=" + country, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },

    })

    const data = await response.json()
    if (data.msg == "success") {

      setStates(data.states)
    }

  }


// console.log(rentalOption);


  // const getPrice = async () => {
  //     const response = await fetch(API_URL+"/check/group?email="+email, {
  //         method: 'GET',
  //         headers: {
  //             'Content-Type': 'application/json',
  //         },

  //     })

  //      const data = await response.json()
  //      if(data.success){
  //         setPrice(data.price)
  //      }

  // }

  const [logging, setLogging] = useState(false);

  const applyscholarshipcode = async () => {
    // $("#paypal-button-container").html('')
    let result = await fetch(API_URL + "/apply/scholarship", {
      method: "POST",

      body: JSON.stringify({
        couponcode: scholarshipCode,
        semsid: trimester,
        payable: totalCost,
        balance: balanceAmount,
      }),
      headers: {
        "Content-Type": "application/json",
      },
    });

    result = await result.json();
    console.warn(result);
    setCodeError(false);
    setScapplied(false);
    setPoapplied(false);
    setTotalCostDiscount(0);
    setBalanceAmountDiscount(0);
    if (result.success) {
      if (result.exist) {
        setTotalCostDiscount(result.discount_amount);
        // alert(result.payable);
        // alert(result.balance);
        setBalanceAmountDiscount(result.balance);
        setScapplied(true);
        if (existingUserId) {
          // setTimeout(() => {
          //     alert(result.discount_amount);
          // payNow(existingUserId) ;
          //  },10000)
        }
      } else {
        setCodeError("Invalid Code");
        // if(existingUserId){

        // setTimeout(() => {
        //     payNow(existingUserId) ;

        //     },2000)
        // }
      }

      // Navigate('/');
    } else {
      setCodeError("Some Error Occured!!!");
      // if(existingUserId){
      //     setTimeout(() => {
      //         payNow(existingUserId);
      //     },2000)
      // }
    }
  };

  const applyponumber = async () => {
    let result = await fetch(API_URL + "/apply/ponumber", {
      method: "POST",

      body: JSON.stringify({
        code: poNumber,
        payable: totalCost,
        balance: balanceAmount,
      }),
      headers: {
        "Content-Type": "application/json",
      },
    });

    result = await result.json();
    console.warn(result);
    setCodeError(false);
    setScapplied(false);
    setPoapplied(false);
    setTotalCostDiscount(0);
    setBalanceAmountDiscount(0);
    if (result.success) {
      if (result.exist) {
        setTotalCostDiscount(result.discount_amount);
        setBalanceAmountDiscount(result.balance);
        setPoapplied(true);
        // if(existingUserId){
        //     setTimeout(() => {
        //         // alert(totalCostDiscount);
        //         payNow(existingUserId) ;
        //     },2000)
        // }
      } else {
        setCodeError("Invalid PO Number");
        // if(existingUserId){
        //     setTimeout(() => {
        //        payNow(existingUserId) ;

        //     },2000)
        // }
      }

      // Navigate('/');
    } else {
      setCodeError("Some Error Occured!!!");
      // if(existingUserId){
      //     setTimeout(() => {
      //         payNow(existingUserId) ;
      //     },2000)
      // }
    }
  };

  const savaFormDataTEST = () => {
    setmessageHead("Success!!");
    setmessage(
      "Your registration was successful.<br /> <br /> You may log into the Professional School e-campus website any time at <a target='_blank' href='https://e-campus.bp.edu' ><u>www.e-campus.bp.edu</u></a> to access course materials and listen to recordings of previous sessions. You will be provided with details during the first course session. <br /> <br /> Thank you!  We look forward to seeing you."
    );
    messageToggle();
  };

  const validate = () => {
    let fields = [
      ["firstname", firstname, "First Name"],
      ["lastname", lastname, "Last Name"],
      ["email", email, "Email Address"],
      ["confirmemail", confirmemail, "Confirm Email Address"],
      ["password", password, "Password"],
      ["confirmPassword", confirmPassword, "Confirm Password"],
      ["telcellNo", telcellNo, "Tel Cell Number"],
      ["address1", address1, "Address Line 1"],
      ["country", country, "Country"],
      ["state", state, "State, province, other"],
      ["city", city, "City"],
      ["postalcode", postalcode, "Postal Code"],
    ];

    if (show) {
      fields = fields.concat([
        ["profession", profession, "Profession"],
        ["highestdegreeearned", highestdegreeearned, "Highest degree earned"],
        ["degreeinwhatfield", degreeinwhatfield, "Degree in what field"],
        ["yeardegreeearned", yeardegreeearned, "Year degree earned"],
        ["licenses", licenses, "Licenses"],
        ["certifications", certifications, "Certifications"],
        ["yearsofprofessionalexperience", yearsofprofessionalexperience, "Years of professional experience"],
        ["whoreferredyou", whoreferredyou, "Who referred you"],
      ]);
    }

    let errs = {};
    fields.forEach(([key, value, label]) => {
      if (value == "") {
        errs[key] = label + " is required.";
      }
      else if (key == "email" && !ValidateEmail(value)) {
        errs[key] = "Email not valid.";
      }
      else if (key == "confirmemail" && value != email) {
        errs[key] = "Email doesn't match.";
      }
      else if (key == "confirmPassword" && value != password) {
        errs[key] = "Password doesn't match.";
      }
    });

    if (rentalOption == 1 && rentalOpted == null) {
      errs.rentalOpted = "Please select your choice for CapnoTrainer GO instrumentation requirement.";
    }

    return errs;
  };

  const fieldErrors = submitted ? validate() : {};
  const errorBorder = (key) => fieldErrors[key] ? { border: "1px solid red" } : undefined;
  const fieldError = (key) => fieldErrors[key] ? <small className="text-danger d-block">{fieldErrors[key]}</small> : null;

  const savaFormData = () => {
    setSubmitted(true);
    const errs = validate();
    if (Object.keys(errs).length > 0) {
      setmessageHead("Error!");
      setmessage("<b>Please enter the required fields:</b><br />" + Object.values(errs).map((v) => "&bull; " + v).join("<br />"));
      messageToggle();
      return false;
    }

    let _member = {
      firstname,
      lastname,
      email,
      confirmemail,
      password,
      confirmPassword,
      telofficeNo,
      telcellNo,
      address1,
      address2,
      country,
      state,
      city,
      postalcode,
      profession,
      highestdegreeearned,
      degreeinwhatfield,
      yeardegreeearned,
      licenses,
      certifications,
      yearsofprofessionalexperience,
      whoreferredyou,
      show,
    };
    let _cost = parseFloat(totalCost - totalCostDiscount).toFixed(2);
    let _balanceAmount = parseFloat(
      balanceAmount - balanceAmountDiscount
    ).toFixed(2);
    let formData = new FormData();

    formData.append("fname", firstname);
    formData.append("lname", lastname);
    formData.append("email", email);
    formData.append("username", email);
    formData.append("password", password);
    formData.append("phone", telofficeNo);
    formData.append("mobile", telcellNo);
    formData.append("add1", address1);
    formData.append("add2", address2);
    formData.append("country", country);
    formData.append("state", state);
    formData.append("city", city);
    formData.append("zip", postalcode);
    formData.append("paymentoptions", "full");
    formData.append("amount", price);
    formData.append("semsids", trimester);
    formData.append("classes", course);
    if(rentalOption==1){
      formData.append("rentalOpted", rentalOpted);
    }
    if (show) {
      formData.append("profession", profession);
      formData.append("highestdeg", highestdegreeearned);
      formData.append("degrefield", degreeinwhatfield);
      formData.append("yeardegree", yeardegreeearned);
      formData.append("licenses", licenses);
      formData.append("certifications", certifications);
      formData.append("experienceyears", yearsofprofessionalexperience);
      formData.append("referredyou", whoreferredyou);

      formData.append("cv", cvFile.current.files[0]);
    }

    fetch(API_URL + "/create/user", {
      method: "POST",

      body: formData,
    }).then(async (result) => {
      // console.warn("result",result);
      const data = await result.json();
      if (data.status) {
        //    setUserId(data.id)
        if (price == 0) {
          completeRegisteration(
            { type: "special zero" },
            data.id,
            _cost,
            _balanceAmount,
            0,
            0
          );
        } else {
          payPalToggle();

          setNewUserId(data.id);
          // setTimeout(() => {
          //      payNow(data.id) ;
          // },2000)
        }
      } else if (data.exist) {
        setmessageHead("Error!");
        setmessage(
          "You're an existing student. Please use a different email address or login to continue"
        );
        messageToggle();
      } else {
        setmessageHead("Error!");
        setmessage("Server Error.");
        messageToggle();
      }
    });
  };

  useEffect(() => {
    if (existingUserId) {
      
      payNow(existingUserId);
    } else {
      payNow(newUserId);
    }
  }, [
    newUserId,
    existingUserId,
    totalCostDiscount,
    totalCost,
    balanceAmount,
    balanceAmountDiscount,
    selectedOption
  ]);

  const payNow = (id) => {
    // alert(totalCostDiscount)
    $("#paypal-button-container").html("");
    setRegistering(false);

    let _cost = parseFloat(totalCost - totalCostDiscount).toFixed(2);

    let _balanceAmount = parseFloat(
      balanceAmount - balanceAmountDiscount
    ).toFixed(2);
    paypal
      .Buttons({
        createOrder: function (data, actions) {
          return actions.order.create({
            purchase_units: [
              {
                amount: {
                  value: parseFloat(_cost),
                },
              },
            ],
          });
        },
        onApprove: function (data, actions) {
          return actions.order.capture().then(function (details) {
            //   console.log(details)
             payPalToggle()
                      loaderToggle()
              completeRegisteration(details, id, _cost, _balanceAmount,0,0);
          });
        },
        onCancel: function (data) {
          // window.location.replace("<?php echo $site_url;?>sales/CeRegister_new_back.php")
        },
      })
      .render("#paypal-button-container");

 
 

  };

  const completeRegisteration = async (details, id, _cost, _balanceAmount,customerId,paymentMethodToken) => {
    setRegistering(true);

    const requestUrl = existingUserId
      ? API_URL + "/complete/registration/existing/installment/" + existingUserId
      : API_URL + "/complete/registration/new/installment/" + newUserId;
    const response = await fetch(requestUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        classes: course,
        semsids: trimester,
        details,
        paidAmount: _cost,
        discountcoupon: scholarshipCode,
        pocode: poNumber,
        balance: _balanceAmount,
        referer: referer,
        paymentMethod: selectedOption=="total"?"full":selectedOption,
        customerId: customerId,        
        paymentMethodToken: paymentMethodToken
      }),
    });

    const data = await response.json();

    if (data.status) {
      setmessageHead("Success!!");
      // alert(course)
                            setLoaderModal(false)

      if (course == 780) {
        setmessage("Your registration was successful.<br /> <br /> You may log into the Professional School e-campus website any time at <a target='_blank' href='https://e-campus.bp.edu' ><u>www.e-campus.bp.edu</u></a> to access course materials (assignments, files, slides, practicum instructions), listen to the prerecorded modules, take module quizzes, access your Professional School CapnoLearning Database, listen to recordings of live sessions (the Orientation, 4-Q&A, and the Practicum Interview), and make an appointment for your Practicum Interview. <br /> <br /> If you are previous student and or have simultaneously signed up for another course, you can access the main e-campus site by clicking on “e-campus” header that will appear on the CapnoLearning landing page.<br /> <br /> You will now be auto-redirected to e-campus in 60 seconds.");

      }
      else {
        setmessage(
          "Your registration was successful.<br /> <br /> You may log into the Professional School e-campus website any time at <a target='_blank' href='https://e-campus.bp.edu' ><u>www.e-campus.bp.edu</u></a> to access course materials and listen to recordings of previous sessions. You will be provided with details during the first course session. <br /> <br /> Thank you!  We look forward to seeing you. <br /> <br /> You will now be auto-redirected to e-campus in few seconds."
        );
      }
      messageToggle();

      setTimeout(() => {
        if (course == 780) {
          window.location.replace("https://e-learning-client-dun.vercel.app/authenticate?token=" + data.token)
        }
        else {
          window.location.replace(
            "https://e-campus.bp.edu/autologin.php?uid=" + data.id
          );
        }
        // window.location.replace('https://neuroacrobatics.com/thank-you-module-one/')
      }, 60000);
    } else {
                            setLoaderModal(false)

      setmessageHead("Error!!");
      setmessage("Some Error Occured");
      setRegistering(false);
      messageToggle();
    }
  };

  function ValidateEmail(mail) {
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
      return true;
    }
    // alert("You have entered an invalid email address!")
    return false;
  }

  const LoginUser = async () => {
    setLogging(true);

    let result = await fetch(API_URL + "/login", {
      method: "POST",

      body: JSON.stringify({
        mail,
        pass,
      }),
      headers: {
        "Content-Type": "application/json",
      },
    });

    result = await result.json();
    console.warn(result);
    setAlertMM(false);
    if (result.success) {
      localStorage.setItem("existingUserId", result.user);
      payPalToggle();

      setExistingUserId(result.user);
      LoginToggleModal();
      setLogging(false);

      //     setTimeout(() => {
      //         payNow(result.user) ;
      //    },2000)
      // Navigate('/');
    } else {
      setAlertMM(true);
      setLogging(false);

    }
  };
  useEffect(() => {
    if (selectedOption == "total") {
      setTotalCost(parseFloat(price).toFixed(2))
      setBalanceAmount(0)
    } 
    else  if (selectedOption == "deposit")  {
      setTotalCost(parseFloat(damount_new).toFixed(2))
      setBalanceAmount(parseFloat(bamount_new).toFixed(2))
    }
    else  if (selectedOption == "installment") {
      setTotalCost(parseFloat(damount_new).toFixed(2))
      setBalanceAmount(parseFloat(bamount_new).toFixed(2))

    }
  }, [selectedOption])

  // installment due dates of the course (from its start date)
  useEffect(() => {
    if (!course) {
      return;
    }
    fetch(API_URL + "/get/installment/dates/" + course)
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          setInstallmentDueDates(data.dates);
        }
      })
      .catch((err) => console.error("Error fetching installment dates:", err));
  }, [course]);

  const formatInstallmentDate = (ts) => {
    const date = new Date(ts * 1000); // Convert seconds to milliseconds
    return date.toLocaleDateString("en-US", { month: "short", day: "2-digit", year: "numeric" });
  };

  // balance split in 3 equal monthly installments from the course start date, fee added to the last one
  // (same calculation as getInstallmentSchedule in the api, the actual dates come from the api and are shown 2 days earlier here)
  const installmentCount = 3;
  const installmentDaysBefore = 2;
  const installmentBalance = parseFloat(
    ((parseFloat(bamount_new) || 0) - (selectedOption == "installment" ? balanceAmountDiscount : 0)).toFixed(2)
  );
  const installments = installmentBalance > 0 && installmentDueDates.length == installmentCount ?
    Array.from({ length: installmentCount }, (_, i) => {
      const perInstallment = Math.floor((installmentBalance / installmentCount) * 100) / 100;
      const isLast = i == installmentCount - 1;
      const amount = isLast ? installmentBalance - perInstallment * (installmentCount - 1) + installmentFee : perInstallment;
      const date = formatInstallmentDate(installmentDueDates[i] - installmentDaysBefore * 86400);
      return { date, amount: amount.toFixed(2), isLast };
    })
    : [];


  return (
    <div>
      {
        slug == "capnolearning" ?
        <div></div>
    :
    <div className="main-bg">
      <Helmet>
        <script
          async
          src="https://www.googletagmanager.com/gtag/js?id=AW-16465521753"
        ></script>
        <script>{`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', 'AW-16465521753');
        `}</script>
        <script>{`
          gtag('event', 'conversion', {'send_to': 'AW-16465521753/9L8iCIjc39kZENnYr6s9'});
        `}</script>
      </Helmet>
      <Modal
        isOpen={successModal}
        toggle={successToggleModal}
        className="connect-box"
        centered={true}
      >
        <ModalHeader toggle={successToggleModal}>
          <span className="ml-1 roititle font-weight-bold">Login</span>
        </ModalHeader>
        <ModalBody>
          <div className="modal-p">
            <div>
              <div className="wrp-login">
                <div className="login-content">
                  <div className="wrp-label">
                    <label>Email Address</label>
                    <input
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      type="email"
                      placeholder="Email"
                    />
                  </div>
                  <div className="wrp-label mrt-input">
                    <label>Password</label>
                    <input
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      type="password"
                      placeholder="Password"
                    />
                  </div>

                  {alertM && <Alert color="danger">Invalid Login</Alert>}

                  <button
                    className="login-btn"
                    type="submit"
                    onClick={LoginUser}
                  >
                    Login{" "}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
      <Header />

      <Faculty message={"Please register for " + courseName} />
      {p_brochure &&
        !showForm &&
        (slug === "optimizing-respiration-for-achieving-high-performance" ? (
          <RespirationBrochure
            checkoutsuccessToggleModal={checkoutsuccessToggleModal}
            setShowForm={setShowForm}
            show={showBrochure}
            setShow={setShowBrochure}
          />
        ) : slug === "breathing-science-for-birth-professionals" ? (
          <PregencyBrochure
            checkoutsuccessToggleModal={checkoutsuccessToggleModal}
            setShowForm={setShowForm}
            show={showBrochure}
            setShow={setShowBrochure}
          />
        ) : slug === "optimizing-respiration-for-high-performance" ?
          (
            <HighPerformaceRespiration
              checkoutsuccessToggleModal={checkoutsuccessToggleModal}
              setShowForm={setShowForm}
              show={showBrochure}
              setShow={setShowBrochure}
            />
          ) :
          (
            slug === "capnolearning" &&
            showBrochure_ === "true" && (
              <CapnolearningBrochure
                checkoutsuccessToggleModal={checkoutsuccessToggleModal}
                setShowForm={setShowForm}
                show={showBrochure}
                setShow={setShowBrochure}
              />
            )
          ))}

      {(slug === "breathing-science-for-birth-professionals" ||
        slug === "optimizing-respiration-for-achieving-high-performance" ||
        slug == "optimizing-respiration-for-high-performance" ||
        (slug === "capnolearning" && showBrochure_ === "true")) &&
        showForm ? (
        <div className="wrp-welcome-page">
          <div className="container">
            <div className="welcome-content">
              {/* <div className="welcome-head">
                            <h3>WELCOME</h3>
                         <h4>Professional School of Behavioral Health Sciences</h4> 

                        </div> */}
              <div className="registration-from">
                {/* <p>Please complete your Registration profile as shown below</p> */}
              </div>
              {/* <div className='registration-from-bottom'>
                            <p>Upon completion of the program, you will receive a transcript and a Certificate of Completion by email.</p>
                        </div> */}
            </div>
          </div>
          <form>
            <div className="form-main-wrap">
              <div className="container">
                <div className="form-wrap">
                  <ul className="form">
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        marginBottom: "1rem",
                      }}
                    >
                      <div className="r-but2" style={{ width: "120px" }}>
                        <a
                          style={{ margin: "0" }}
                          onClick={() => setShowForm(false)}
                        >
                          Go Back
                        </a>
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        flexWrap: "wrap",
                      }}
                    >
                     
                      <div>
                      <small>Click here to <u><a href="#" onClick={()=>setProgramRequisitModal(!programRequisitModal)}>review program requirements</a></u>. If in doubt, be sure to contact us at  <u><a href="mailto:education@bp.edu">education@bp.edu</a></u>.</small>
                        <small>
                          If you're an existing student/faculty member please{" "}
                          <u>
                            <a
                              style={{ cursor: "pointer" }}
                              onClick={() => setLoginModel(!loginModel)}
                            >
                              click here{" "}
                            </a>
                          </u>
                          to proceed to checkout.
                        </small>
                        <h3 className="mb-0 mt-1">Registration Profile </h3>

                      </div>
                      <a
                        target="_blank"
                        href={brochureLink}
                        style={{ textDecoration: "none" }}
                      >
                        <img
                          alt="download"
                          src={download}
                          style={{
                            width: "20px",
                            marginRight: "5px",
                            marginTop: "-2px",
                          }}
                        />
                        <span>Download Brochure</span>
                      </a>
                    </div>
                    <li>
                      <div className="input-list">
                        <p>First Name *</p>
                        <input style={errorBorder("firstname")}
                          type="text"
                          onChange={(e) => setFirstname(e.target.value)}
                          placeholder="Enter first name"
                        ></input>
                        {fieldError("firstname")}
                      </div>
                      <div className="input-list">
                        <p>Last Name *</p>
                        <input style={errorBorder("lastname")}
                          type="text"
                          onChange={(e) => setLastname(e.target.value)}
                          placeholder="Enter last name"
                        ></input>
                        {fieldError("lastname")}
                      </div>
                      <div className="input-list">
                        <p>Email Address (Username) *</p>
                        <input autoComplete="off" style={errorBorder("email")}
                          type="text"
                          onChange={(e) => setEmail(e.target.value)}
                          placeholder="Enter email"
                        ></input>
                        {fieldError("email")}
                      </div>
                      <div className="input-list">
                        <p>Confirm Email Address *</p>
                        <input autoComplete="off" style={errorBorder("confirmemail")}
                          onChange={(e) => setConfirmEmail(e.target.value)}
                          placeholder="Enter email"
                        ></input>
                        {fieldError("confirmemail")}
                      </div>
                    </li>

                    <li>
                      <div className="input-list">
                        <p>Password *</p>
                        <input autoComplete="new-password" style={errorBorder("password")}
                          onChange={(e) => setPassword(e.target.value)}
                          type="password"
                          placeholder="Enter password"
                        ></input>
                        {fieldError("password")}
                      </div>
                      <div className="input-list">
                        <p>Confirm Password *</p>
                        <input autoComplete="new-password" style={errorBorder("confirmPassword")}
                          onChange={(e) => setConfirmPassword(e.target.value)}
                          type="password"
                          placeholder="Enter password"
                        ></input>
                        {fieldError("confirmPassword")}
                      </div>
                      <div className="input-list">
                        <p>Tel Office Number</p>
                        <input
                          onChange={(e) => setTelofficeNo(e.target.value)}
                          type="text"
                          placeholder="Enter office number"
                        ></input>
                      </div>
                      <div className="input-list">
                        <p>Tel Cell Number *</p>
                        <input style={errorBorder("telcellNo")}
                          onChange={(e) => setTelcellNo(e.target.value)}
                          type="text"
                          placeholder="Enter cell number"
                        ></input>
                        {fieldError("telcellNo")}
                      </div>
                    </li>
                    <li>
                      <div className="input-list2">
                        <p>Address Line 1 *</p>
                        <input style={errorBorder("address1")}
                          onChange={(e) => setAddress1(e.target.value)}
                          type="text"
                          placeholder="Enter Street address"
                        ></input>
                        {fieldError("address1")}
                      </div>
                      <div className="input-list2">
                        <p>Address Line 2 </p>
                        <input
                          onChange={(e) => setAddress2(e.target.value)}
                          type="text"
                          placeholder="Enter apartment, suite, unit etc (optional)"
                        ></input>
                      </div>
                    </li>
                    <li>
                      {countries.length > 0 && (
                        <div className="input-list">
                          <p>Country *</p>
                          <select style={errorBorder("country")}
                            className=""
                            onChange={(e) => setCountry(e.target.value)}
                          >
                            <option value={""}>Select Country</option>
                            {countries.map((v, i) => {
                              return <option value={v.id}>{v.Name}</option>;
                            })}
                          </select>
                          {fieldError("country")}
                        </div>
                      )}

                      <div className="input-list">
                        <p>State, province, other *</p>

                        {
                          states.length == 0 ?
                            <input style={errorBorder("state")} onChange={(e) => setState(e.target.value)} type='text' placeholder='State, province, other *'></input>

                            :
                            <select style={errorBorder("state")} className="" onChange={(e) => setState(e.target.value)} >
                              <option value={''}>Select State</option>
                              {
                                states.map((v, i) => {
                                  return (
                                    <option value={v.name}>{v.name}</option>
                                  )

                                })
                              }

                            </select>
                        }
                        {fieldError("state")}

                      </div>
                      <div className="input-list">
                        <p>City *</p>
                        <input style={errorBorder("city")}
                          onChange={(e) => setCity(e.target.value)}
                          type="text"
                          placeholder="Select city"
                        ></input>
                        {fieldError("city")}
                      </div>
                      <div className="input-list">
                        <p>Postal Code *</p>
                        <input style={errorBorder("postalcode")}
                          onChange={(e) => setPostalcode(e.target.value)}
                          type="text"
                          placeholder="Enter postal code"
                        ></input>
                        {fieldError("postalcode")}
                      </div>
                    </li>
                    {slug === "capnolearning"  || show ? (
                      <div className="professional-content"></div>
                    ) : (
                      <div className="professional-content">
                        {/* <h3>Professional Certificate in NeuroAcrobatics™</h3> */}
                        <p className="text-justify">
                          If you plan to earn a{" "}
                          <b>Professional Certificate in {courseName}</b>, click
                          here:{" "}
                          <u>
                            <b
                              style={{ cursor: "pointer" }}
                              onClick={() => setShow(!show)}
                            >
                              Professional Background Profile.
                            </b>
                          </u>
                        </p>
                        {/* <p>If applicable, click here to complete your  (only for those interested in earning a Professional Certificate)</p> */}
                      </div>
                    )}

                    {show ? (
                      <div>
                        <ul className="form">
                          <li>
                            <div className="input-list">
                              <p>Profession *</p>
                              <input style={errorBorder("profession")}
                                onChange={(e) => setProfession(e.target.value)}
                                type="text"
                                placeholder=""
                              ></input>
                              {fieldError("profession")}
                            </div>
                            <div className="input-list">
                              <p>Highest degree earned *</p>
                              <input style={errorBorder("highestdegreeearned")}
                                onChange={(e) =>
                                  setHighestdegreeearned(e.target.value)
                                }
                                type="text"
                                placeholder=""
                              ></input>
                              {fieldError("highestdegreeearned")}
                            </div>
                            <div className="input-list">
                              <p>Degree in what field *</p>
                              <input style={errorBorder("degreeinwhatfield")}
                                onChange={(e) =>
                                  setDegreeinwhatfield(e.target.value)
                                }
                                type="text"
                                placeholder=""
                              ></input>
                              {fieldError("degreeinwhatfield")}
                            </div>
                            <div className="input-list">
                              <p>Year degree earned *</p>
                              <input style={errorBorder("yeardegreeearned")}
                                onChange={(e) =>
                                  setyeardegreeearned(e.target.value)
                                }
                                type="text"
                                placeholder=""
                              ></input>
                              {fieldError("yeardegreeearned")}
                            </div>
                          </li>
                          <li>
                            <div className="input-list1">
                              <p>Licenses (Indicate NA if none.) *</p>
                              <input style={errorBorder("licenses")}
                                onChange={(e) => setLicenses(e.target.value)}
                                type="text"
                                placeholder=""
                              ></input>
                              {fieldError("licenses")}
                            </div>
                            <div className="input-list1">
                              <p>Certifications (Indicate NA if none.) *</p>
                              <input style={errorBorder("certifications")}
                                type="text"
                                onChange={(e) =>
                                  setCertifications(e.target.value)
                                }
                                placeholder=""
                              ></input>
                              {fieldError("certifications")}
                            </div>
                          </li>
                          <li style={{ flexWrap: "wrap", gap: "10px" }}>
                            <div className="input-list input-list4">
                              <p>Years of professional experience *</p>
                              <input style={errorBorder("yearsofprofessionalexperience")}
                                onChange={(e) =>
                                  setYearsofprofessionalexperience(
                                    e.target.value
                                  )
                                }
                                type="text"
                                placeholder=""
                              ></input>
                              {fieldError("yearsofprofessionalexperience")}
                            </div>
                            <div className="input-list input-list4">
                              <p>Who referred you?*</p>
                              {/* <input
                                type="text"
                                onChange={(e) =>
                                  setWhoreferredyou(e.target.value)
                                }
                                placeholder="Who referred you"
                              ></input> */}
                              <select style={errorBorder("whoreferredyou")} onChange={refervalue} >
                                <option value="" data-title="Website Link" data-id="0">Please Choose</option>
                                <option value="School website or email" data-title="Website Link" data-id="0">School website or email</option>
                                <option value="Social Media, e.g., Facebook" data-title="Website Link" data-id="1">Social Media, e.g., Facebook</option>
                                <option value="Faculty, Student, or Admin" data-title="Specify name" data-id="1">Faculty, Student, or Admin</option>
                                <option value="Employer" data-title="Specify Name" data-id="1">Employer</option>
                                <option value="Personal friend" data-title="Name" data-id="1">Personal friend</option>
                                <option value="Professional colleague" data-title="Name" data-id="1">Professional colleague</option>
                                <option value="Other: Please specify source" data-title="Name" data-id="1">Other: Please specify source</option>

                              </select>
                              {fieldError("whoreferredyou")}
                            </div>
                            {
                              showOtherRefer ?
                                <>
                                  <div className='input-list' style={{ width: "30%" }}>
                                    <p>Please specify source </p>
                                    <input onChange={(e) => setSource(e.target.value)} type='text' placeholder=''></input>
                                  </div>
                                </>
                                :
                                null
                            }

                            <div className="list5">
                              <p>Upload CV</p>
                              <input
                                type="file"
                                id="myfile"
                                name="myfile"
                                ref={cvFile}
                              ></input>
                            </div>
                          </li>
                        </ul>
                      </div>
                    ) : null}
                  
                    
                    <div className="r-but2">
                      <a onClick={savaFormData}>
                        REGISTER AND PAY NOW (${price})
                      </a>
                    </div>
                  </ul>
                </div>
              </div>
            </div>
          </form>

          <form>
            <div className="form-main-wrap">
              <div className="container"></div>
            </div>
          </form>
        </div>
      ) : (
        slug !== "breathing-science-for-birth-professionals" &&
        slug !== "optimizing-respiration-for-high-performance" &&
        slug !== "optimizing-respiration-for-achieving-high-performance" &&

        showBrochure_ !== "true" && (
          <div className="wrp-welcome-page">
            <div className="container">
              <div className="welcome-content">
                {/* <div className="welcome-head">
                            <h3>WELCOME</h3>
                         <h4>Professional School of Behavioral Health Sciences</h4> 

                        </div> */}
                <div className="registration-from">
                  {/* <p>Please complete your Registration profile as shown below</p> */}
                </div>
                {/* <div className='registration-from-bottom'>
                            <p>Upon completion of the program, you will receive a transcript and a Certificate of Completion by email.</p>
                        </div> */}
              </div>
            </div>
            <form>
              <div className="form-main-wrap">
                <div className="container">
                  <div className="form-wrap">
                    <ul className="form">
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          flexWrap: "wrap",
                        }}
                      >
                        <div>
                           <small>Click here to <u><a href="#" onClick={()=>setProgramRequisitModal(!programRequisitModal)}>review program requirements</a></u>. If in doubt, be sure to contact us at  <u><a href="mailto:education@bp.edu">education@bp.edu</a></u>.</small><br />
                            <small>
                            If you're an existing student/faculty member please{" "}
                            <u>
                              <a
                                onClick={() => setLoginModel(!loginModel)}
                                style={{ cursor: "pointer", color: "purple" }}
                              >click here </a>
                            </u>
                            to proceed to checkout.
                          </small>
                          <h5 className="mb-0 mt-2">Registration Profile </h5>
                         
                        </div>
                        <a
                          target="_blank"
                          href={brochureLink}
                          style={{ textDecoration: "none" }}
                        >
                          <img
                            alt="download"
                            src={download}
                            style={{
                              width: "20px",
                              marginRight: "5px",
                              marginTop: "-2px",
                            }}
                          />
                          <span>Download Brochure</span>
                        </a>
                      </div>
                      <li className="mt-1">
                        <div className="input-list">
                          <p>First Name *</p>
                          <input style={errorBorder("firstname")}
                            type="text"
                            onChange={(e) => setFirstname(e.target.value)}
                            placeholder="Enter first name"
                          ></input>
                          {fieldError("firstname")}
                        </div>
                        <div className="input-list">
                          <p>Last Name *</p>
                          <input style={errorBorder("lastname")}
                            type="text"
                            onChange={(e) => setLastname(e.target.value)}
                            placeholder="Enter last name"
                          ></input>
                          {fieldError("lastname")}
                        </div>
                        <div className="input-list">
                          <p>Email Address (Username) *</p>
                          <input autoComplete="off" style={errorBorder("email")}
                            type="text"
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="Enter email"
                          ></input>
                          {fieldError("email")}
                        </div>
                        <div className="input-list">
                          <p>Confirm Email Address *</p>
                          <input autoComplete="off" style={errorBorder("confirmemail")}
                            onChange={(e) => setConfirmEmail(e.target.value)}
                            placeholder="Enter email"
                          ></input>
                          {fieldError("confirmemail")}
                        </div>
                      </li>

                      <li>
                        <div className="input-list">
                          <p>Password *</p>
                          <input autoComplete="new-password" style={errorBorder("password")}
                            onChange={(e) => setPassword(e.target.value)}
                            type="password"
                            placeholder="Enter password"
                          ></input>
                          {fieldError("password")}
                        </div>
                        <div className="input-list">
                          <p>Confirm Password *</p>
                          <input autoComplete="new-password" style={errorBorder("confirmPassword")}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            type="password"
                            placeholder="Enter password"
                          ></input>
                          {fieldError("confirmPassword")}
                        </div>
                        <div className="input-list">
                          <p>Tel Office Number</p>
                          <input
                            onChange={(e) => setTelofficeNo(e.target.value)}
                            type="text"
                            placeholder="Enter office number"
                          ></input>
                        </div>
                        <div className="input-list">
                          <p>Tel Cell Number *</p>
                          <input style={errorBorder("telcellNo")}
                            onChange={(e) => setTelcellNo(e.target.value)}
                            type="text"
                            placeholder="Enter cell number"
                          ></input>
                          {fieldError("telcellNo")}
                        </div>
                      </li>
                      <li>
                        <div className="input-list2">
                          <p>Address Line 1 *</p>
                          <input style={errorBorder("address1")}
                            onChange={(e) => setAddress1(e.target.value)}
                            type="text"
                            placeholder="Enter Street address"
                          ></input>
                          {fieldError("address1")}
                        </div>
                        <div className="input-list2">
                          <p>Address Line 2 </p>
                          <input
                            onChange={(e) => setAddress2(e.target.value)}
                            type="text"
                            placeholder="Enter apartment, suite, unit etc (optional)"
                          ></input>
                        </div>
                      </li>
                      <li>
                        {countries.length > 0 && (
                          <div className="input-list">
                            <p>Country *</p>
                            <select style={errorBorder("country")}
                              className=""
                              onChange={(e) => setCountry(e.target.value)}
                            >
                              <option value={""}>Select Country</option>
                              {countries.map((v, i) => {
                                return <option value={v.id}>{v.Name}</option>;
                              })}
                            </select>
                            {fieldError("country")}
                          </div>
                        )}

                        <div className="input-list">
                          <p>State, province, other *</p>
                          {/* <input
                            onChange={(e) => setState(e.target.value)}
                            type="text"
                            placeholder="State, province, other *"
                          ></input> */}


                          {
                            states.length == 0 ?
                              <input style={errorBorder("state")} onChange={(e) => setState(e.target.value)} type='text' placeholder='State, province, other *'></input>

                              :
                              <select style={errorBorder("state")} className="" onChange={(e) => setState(e.target.value)} >
                                <option value={''}>Select State</option>
                                {
                                  states.map((v, i) => {
                                    return (
                                      <option value={v.name}>{v.name}</option>
                                    )

                                  })
                                }

                              </select>
                          }
                          {fieldError("state")}


                        </div>
                        <div className="input-list">
                          <p>City *</p>
                          <input style={errorBorder("city")}
                            onChange={(e) => setCity(e.target.value)}
                            type="text"
                            placeholder="Select city"
                          ></input>
                          {fieldError("city")}
                        </div>
                        <div className="input-list">
                          <p>Postal Code *</p>
                          <input style={errorBorder("postalcode")}
                            onChange={(e) => setPostalcode(e.target.value)}
                            type="text"
                            placeholder="Enter postal code"
                          ></input>
                          {fieldError("postalcode")}
                        </div>
                      </li>
                      {(slug === "capnolearning" || show) ? (
                        <div className="professional-content"></div>
                      ) : (
                        <div className="professional-content">
                          {/* <h3>Professional Certificate in NeuroAcrobatics™</h3> */}
                          <p className="text-justify">
                            If you plan to earn a{" "}
                            <b>Professional Certificate in {courseName}</b>,
                            click here:{" "}
                            <u>
                              <b
                                style={{ cursor: "pointer" }}
                                onClick={() => setShow(!show)}
                              >
                                Professional Backgrounsd Profile.
                              </b>
                            </u>
                          </p>
                          {/* <p>If applicable, click here to complete your  (only for those interested in earning a Professional Certificate)</p> */}
                        </div>
                      )}

                      {show ? (
                        <div>
                          <ul className="form">
                            <li>
                              <div className="input-list">
                                <p>Profession *</p>
                                <input style={errorBorder("profession")}
                                  onChange={(e) =>
                                    setProfession(e.target.value)
                                  }
                                  type="text"
                                  placeholder=""
                                ></input>
                                {fieldError("profession")}
                              </div>
                              <div className="input-list">
                                <p>Highest degree earned *</p>
                                <input style={errorBorder("highestdegreeearned")}
                                  onChange={(e) =>
                                    setHighestdegreeearned(e.target.value)
                                  }
                                  type="text"
                                  placeholder=""
                                ></input>
                                {fieldError("highestdegreeearned")}
                              </div>
                              <div className="input-list">
                                <p>Degree in what field *</p>
                                <input style={errorBorder("degreeinwhatfield")}
                                  onChange={(e) =>
                                    setDegreeinwhatfield(e.target.value)
                                  }
                                  type="text"
                                  placeholder=""
                                ></input>
                                {fieldError("degreeinwhatfield")}
                              </div>
                              <div className="input-list">
                                <p>Year degree earned *</p>
                                <input style={errorBorder("yeardegreeearned")}
                                  onChange={(e) =>
                                    setyeardegreeearned(e.target.value)
                                  }
                                  type="text"
                                  placeholder=""
                                ></input>
                                {fieldError("yeardegreeearned")}
                              </div>
                            </li>
                            <li>
                              <div className="input-list1">
                                <p>Licenses (Indicate NA if none.) *</p>
                                <input style={errorBorder("licenses")}
                                  onChange={(e) => setLicenses(e.target.value)}
                                  type="text"
                                  placeholder=""
                                ></input>
                                {fieldError("licenses")}
                              </div>
                              <div className="input-list1">
                                <p>Certifications (Indicate NA if none.) *</p>
                                <input style={errorBorder("certifications")}
                                  type="text"
                                  onChange={(e) =>
                                    setCertifications(e.target.value)
                                  }
                                  placeholder=""
                                ></input>
                                {fieldError("certifications")}
                              </div>
                            </li>
                            <li style={{ flexWrap: "wrap", gap: "10px" }}>
                              <div className="input-list input-list4">
                                <p>Years of professional experience *</p>
                                <input style={errorBorder("yearsofprofessionalexperience")}
                                  onChange={(e) =>
                                    setYearsofprofessionalexperience(
                                      e.target.value
                                    )
                                  }
                                  type="text"
                                  placeholder=""
                                ></input>
                                {fieldError("yearsofprofessionalexperience")}
                              </div>
                              <div className="input-list input-list4">
                                <p>Who referred you?*</p>
                                {/* <input
                                  type="text"
                                  onChange={(e) =>
                                    setWhoreferredyou(e.target.value)
                                  }
                                  placeholder="Who referred you"
                                ></input> */}
                                <select style={errorBorder("whoreferredyou")} onChange={refervalue} >
                                  <option value="" data-title="Website Link" data-id="0">Please Choose</option>
                                  <option value="School website or email" data-title="Website Link" data-id="0">School website or email</option>
                                  <option value="Social Media, e.g., Facebook" data-title="Website Link" data-id="1">Social Media, e.g., Facebook</option>
                                  <option value="Faculty, Student, or Admin" data-title="Specify name" data-id="1">Faculty, Student, or Admin</option>
                                  <option value="Employer" data-title="Specify Name" data-id="1">Employer</option>
                                  <option value="Personal friend" data-title="Name" data-id="1">Personal friend</option>
                                  <option value="Professional colleague" data-title="Name" data-id="1">Professional colleague</option>
                                  <option value="Other: Please specify source" data-title="Name" data-id="1">Other: Please specify source</option>

                                </select>
                                {fieldError("whoreferredyou")}
                              </div>
                              {
                                showOtherRefer ?
                                  <>
                                    <div className='input-list' style={{ width: "30%" }}>
                                      <p>Please specify source </p>
                                      <input onChange={(e) => setSource(e.target.value)} type='text' placeholder=''></input>
                                    </div>
                                  </>
                                  :
                                  null
                              }

                              <div className="list5">
                                <p>Upload CV</p>
                                <input
                                  type="file"
                                  id="myfile"
                                  name="myfile"
                                  ref={cvFile}
                                ></input>
                              </div>
                            </li>
                          </ul>
                        </div>
                      ) : null}

                      {rentalOption==1 && 
                    <div className="mt-4">
                    <p style={{fontSize:"16px",marginBottom:"10px",fontWeight:"bold"}}>
                     CapnoTrainer GO requirement:
                    </p>
                    <p style={{fontSize:"14px",marginBottom:"0px"}}>
                      Candidates are required to rent or own a CapnoTrainer to complete certification requirements with their own volunteer subjects.
                    </p>
                    <p style={{fontSize:"14px",marginBottom:"10px"}}>
                      The CapnoTrainer Rental Option is <strong>$600.00</strong> plus shipping. The rental fee may be applied as credit toward a subsequent CapnoTrainer purchase.
                    </p>
                    <p style={{fontSize:"14px",marginBottom:"10px",fontWeight:"bold",fontStyle:"italic"}}>
                     Please indicate below your intentions regarding CapnoTrainer instrumentation:
                    </p>
                     <div
    style={{
      display: "flex",
      flexWrap: "wrap",
      gap: "10px",

    }}
  >
    {/* Option 1 */}
    <label
      style={{
        display: "flex",
        alignItems: "center",
        gap: "8px",
     
      }}
    >
      <input
        type="radio"
        name="capnoOption"
        value={1}
        checked={rentalOpted === 1}
        onChange={() => setRentalOpted(1)}
        style={{ width: 12, height: 12 }}
      />
      <span style={{fontSize:"14px"}}>I already own a CapnoTrainer</span>
    </label>

    {/* Option 2 */}
    <label
      style={{
        display: "flex",
        alignItems: "center",
        gap: "8px",

      }}
    >
      <input
        type="radio"
        name="capnoOption"
        value={2}
        checked={rentalOpted === 2}
        onChange={() => setRentalOpted(2)}
        style={{ width: 12, height: 12 }}
      />
      <span style={{fontSize:"14px"}}>I plan to buy a CapnoTrainer</span>
    </label>

    {/* Option 3 */}
    <label
      style={{
        display: "flex",
        alignItems: "center",
        gap: "8px",

      }}
    >
      <input
        type="radio"
        name="capnoOption"
        value={3}
        checked={rentalOpted === 3}
        onChange={() => setRentalOpted(3)}
        style={{ width: 12, height: 12 }}
      />
      <span style={{fontSize:"14px"}}>I plan to rent a CapnoTrainer</span>
    </label>
  </div>
                    {fieldError("rentalOpted")}
                    <p style={{fontSize:"14px",marginBottom:"10px"}}>
                     If you plan to rent an instrument, the rental option will appear in your confirmation email.
                    </p>
                    </div>
                    }

                      <div className="r-but2">
                        <a onClick={savaFormData}>
                          REGISTER AND PAY NOW (${price})
                        </a>
                      </div>
                    </ul>
                  </div>
                </div>
              </div>
            </form>

            <form>
              <div className="form-main-wrap">
                <div className="container"></div>
              </div>
            </form>
          </div>
        )
      )}

         <Modal
        isOpen={loaderModal}
        toggle={loaderToggle}
        style={{height: "700px"}}
        className="connect-box"
        centered={true}
      >
        <ModalHeader toggle={loaderToggle}>
          <span className="ml-1 roititle font-weight-bold">
             Processing Payment...
          </span>
        </ModalHeader>
        <ModalBody  style={{maxHeight: "700px"}}>
          <p style={{textAlign: "center"}}>Please wait while we process your payment.</p>
        </ModalBody>
        </Modal>


          <Modal
        isOpen={errorModal}
        toggle={errorToggle}
        style={{height: "700px"}}
        className="connect-box"
        centered={true}
      >
        <ModalHeader toggle={errorToggle}>
          <span className="ml-1 roititle font-weight-bold">
             Error
          </span>
        </ModalHeader>
        <ModalBody  style={{maxHeight: "700px"}}>
          <p style={{textAlign: "center"}}>Error Occured! Kindly retry and if issue persists contact us at education@bp.edu.</p>
        </ModalBody>
        </Modal>

      <Modal
        isOpen={payPalModal}
        toggle={payPalToggle}
        style={{height: "700px"}}
        className="connect-box"
        centered={true}
      >
        <ModalHeader toggle={payPalToggle}>
          <span className="ml-1 roititle font-weight-bold">
             Payment Options
          </span>
        </ModalHeader>
        <ModalBody  style={{maxHeight: "700px"}}>
          <div className="discount-btn">
            <div
            // style={{display:"flex",gap:"10px",alignItems:"center",flexWrap:"wrap"}}
            >
              <h6 style={{ marginBottom: "15px" , fontWeight: 700}}>Credit, Debit Cards, or PayPal</h6>
              <div>
                <label style={{ margin: "0" }}>
                  <input
                    type="radio"
                    value="total"
                    checked={selectedOption === "total"}
                    onChange={handleChange}
                    style={{ marginRight: "5px" }}
                  />
                  <span style={{ marginTop: "10px", fontWeight: 700 }}>${parseFloat(price || 0).toFixed(2)}</span>  full tution fee payment now.
                </label>
              </div>
              {
                (depositEnabled == 1 && new Date(rawBalanceDate) > new Date()) && 
                <div>
                  <label style={{ marginTop: "10px" }}>
                    <input
                      type="radio"
                      value="deposit"
                      checked={selectedOption === "deposit"}
                      onChange={handleChange}
                      style={{ marginRight: "5px" }}
                    />
                    <span style={{ marginTop: "10px", fontWeight: 700 }}>${parseFloat(damount_new || 0).toFixed(2)} deposit</span>, PayPal request for <br /> 
                    <ul style={{marginBottom: "0px"}}><li><span style={{ marginTop: "10px", fontWeight: 400 }}>${parseFloat(bamount_new).toFixed(2)} balance on {balanceDate}.</span></li></ul>
                  </label>
                </div>
              }
              {
                (instalmentEnabled == 1 && new Date(rawBalanceDate) > new Date() && installments.length > 0) &&
                <div>
                  <label style={{ marginTop: "10px" }}>
                    <input
                      type="radio"
                      value="installment"
                      checked={selectedOption === "installment"}
                      onChange={handleChange}
                      style={{ marginRight: "5px" }}
                    />
                    <span style={{ marginTop: "10px", fontWeight: 700 }}>${parseFloat(damount_new || 0).toFixed(2)} deposit</span>, balance in {installments.length} installments <br />
                    <ul style={{marginBottom: "0px"}}>
                      {
                        installments.map((v, i) => {
                          return (
                            <li key={i}><span style={{ marginTop: "10px", fontWeight: 400 }}>${v.amount} on {v.date}.</span></li>
                          )
                        })
                      }
                    </ul>
                  </label>
                </div>
              }
               
              
            </div>
            {/* <strong>Total Payable:</strong> $
            {parseFloat(totalCost - totalCostDiscount).toFixed(2)} */}


            {/* {parseFloat(balanceAmount - balanceAmountDiscount).toFixed(2) >
              0 && (
                <p className="mb-0">
                  <b>Balance due 2 days before program starts:</b> $
                  {parseFloat(balanceAmount - balanceAmountDiscount).toFixed(2)}
                </p>
              )} */}
            {scapplied ? (
              <p className="text-success">
                <i className="fa fa-check-circle"></i> Scholarship Code Applied
              </p>
            ) : poapplied ? (
              <p className="text-success">
                <i className="fa fa-check-circle"></i> PO # (Preapproved)
              </p>
            ) : null}
            {parseFloat(balanceAmount - balanceAmountDiscount).toFixed(2) >
              0 && <hr />}
            {codeError ? (
              <small className="text-danger">
                <i className="fa fa-times"></i> {codeError}
              </small>
            ) : null}
            <div className="coupon-wrp mb-4 mt-2">
              <div className="coupon-child1">
                <label>
                  <b>Scholarship Code</b>
                </label>
                <input
                  onChange={(e) => setScholarshipCode(e.target.value)}
                  placeholder="Enter Scholarship Code"
                />
                <button onClick={applyscholarshipcode}>Apply</button>
              </div>
              <div className="coupon-child1 coupon-right">
                <label>
                  <b>PO # (Preapproved)</b>
                </label>
                <input
                  onChange={(e) => setPoNumber(e.target.value)}
                  placeholder="Enter PO Number"
                />
                <button onClick={applyponumber}>Apply</button>
              </div>
            </div>
            {registering && (
              <button disabled={true}>Completing Registration...</button>
            )}
            {totalCostDiscount >= totalCost && !registering && (
              <button
                onClick={() => completeRegisteration(existingUserId, "", 0, 0, 0 , 0)}
              >
                CheckOut
              </button>
            )}
          </div>

          {totalCost > totalCostDiscount && (
            <>
              <div
                data-pp-message
                data-pp-style-layout="text"
                data-pp-style-logo-type="inline"
                data-pp-style-text-color="black"
                data-pp-amount={totalCost}
                data-pp-placement="payment"
                data-pp-style-text-size="16" >
              </div>
              <div id="paypal-button-container"></div>


            </>
          )}
        </ModalBody>
      </Modal>
      <Modal
        isOpen={checkoutsuccessModel}
        toggle={checkoutsuccessToggleModal}
        className="connect-box"
        centered={true}
      >
        <ModalHeader toggle={checkoutsuccessToggleModal}>
          <span className="ml-1 roititle">Please register</span>
        </ModalHeader>
        <ModalBody>
          <div className="modal-p">
            <div>
              <p>
                {" "}
                Click:{" "}
                <a
                  href="#"
                  onClick={() => {
                    setShowForm(true);
                    checkoutsuccessToggleModal();
                  }}
                >
                  <u>New Student</u>
                </a>{" "}
                <br />
                <br /> Click:{" "}
                <a
                  href="#"
                  onClick={() => {
                    LoginToggleModal();
                    checkoutsuccessToggleModal();
                  }}
                >
                  <u>Existing Student</u>
                </a>
              </p>
            </div>
          </div>
        </ModalBody>
      </Modal>
      <Modal
        isOpen={messageModal}
        toggle={messageToggle}
        className="connect-box"
        centered={true}
      >
        <ModalHeader toggle={messageToggle}>
          <span className="ml-1 roititle font-weight-bold">{messageHead}</span>
        </ModalHeader>
        <ModalBody>
          <div dangerouslySetInnerHTML={{ __html: message }}></div>
        </ModalBody>
      </Modal>
  <Modal isOpen={programRequisitModal} toggle={()=>setProgramRequisitModal(!programRequisitModal)} className="connect-box" centered={true}>
                                    <ModalHeader toggle={()=>setProgramRequisitModal(!programRequisitModal)}><span className="ml-1 roititle font-weight-bold">Prerequisites</span></ModalHeader>
                                    <ModalBody>
                                        <div className="" style={{fontSize: "14px"}}>
                                              <div
                            dangerouslySetInnerHTML={{ __html: prereq }}
                          />
                                        </div>
                                    </ModalBody>
                    
                                </Modal>
      <Modal
        isOpen={loginModel}
        toggle={LoginToggleModal}
        className="connect-box"
        centered={true}
      >
        <ModalHeader toggle={LoginToggleModal}>
          <span className="ml-1 credentials-title">
            Please enter your e-campus credentials to checkout
          </span>
        </ModalHeader>
        <ModalBody>
          <div className="modal-p">
            <div className="login-bg">
              <div className="wrp-login">
                <div className="login-content">
                  <div className="wrp-label">
                    <label>Email Address</label>
                    <input
                      value={mail}
                      onChange={(e) => setMail(e.target.value)}
                      type="email"
                      placeholder="Email"
                    />
                  </div>
                  <div className="wrp-label mrt-input">
                    <label>Password</label>
                    <div className="wrp-label" style={{ position: "relative" }}>
                      <input
                        value={pass}
                        onChange={(e) => setPass(e.target.value)}
                        type={showPassword ? "text" : "password"}
                        placeholder="Password"
                        style={{ paddingRight: "40px" }}
                      />
                      <i
                        className={showPassword ? "fa fa-eye-slash" : "fa fa-eye"}
                        onClick={() => setShowPassword(!showPassword)}
                        style={{
                          position: "absolute",
                          right: "14px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          cursor: "pointer",
                          color: "#000",
                        }}
                      ></i>
                    </div>
                  </div>

                  {alertM && <Alert color="danger">Invalid Login</Alert>}
                  {logging ? (
                    <button className="login-btn" disabled>
                      Logging in...
                    </button>
                  ) : (
                    <button
                      className="login-btn"
                      type="submit"
                      onClick={LoginUser}
                    >
                      CheckOut
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </div>
      }
    </div>

  );
};
export default SpecialRegisterform;
